// ============================================================
// UrbanWear -- AnnouncementBar.tsx
// Cintilla superior con textos desde la config del sitio
// ============================================================
import { useQuery } from '@tanstack/react-query'
import { api } from '@/utils/api'
import styles from './AnnouncementBar.module.css'

export default function AnnouncementBar() {
  const { data: config } = useQuery({
    queryKey: ['site-config'],
    queryFn:  () => api.get('/site-config').then(r => r.data),
    staleTime: 5 * 60 * 1000, // 5 minutos
  })

  const texts: string[] = config?.banner ?? [
    'NUEVA COLECCION 2025',
    'ENVIOS GRATIS EN COMPRAS MAYORES A $1,500',
    'MAYOREO DESDE 12 PIEZAS - 20% DE DESCUENTO',
    'DEVOLUCIONES GRATUITAS EN 30 DIAS',
  ]

  return (
    <div className={styles.bar}>
      <div className={styles.track}>
        {/* Duplicamos para loop continuo */}
        {[...texts, ...texts].map((text, i) => (
          <span key={i} className={styles.item}>
            <span className={styles.dot}>+</span>
            {text}
          </span>
        ))}
      </div>
    </div>
  )
}
